"use client";

import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";

import { Button } from "@/src/components/shadcn/ui/button";
import { ValerieCard } from "@/src/components/valerie-card";

export interface EditableCardProps<T> {
  title: string;
  icon: LucideIcon;
  initialData: T;
  onCancel: () => void;
  onSave: (updatedData: T) => Promise<void>;
  children: ReactNode;
  isSaving: boolean;
  createMode?: boolean;
}

export default function EditableCard<T>({
  title,
  icon: Icon,
  initialData,
  onCancel,
  onSave,
  children,
  isSaving,
  createMode = false,
}: EditableCardProps<T>) {
  const handleSave = async () => {
    await onSave(initialData);
  };

  const saveButtonText = createMode ? "Create" : "Update";
  const saveButtonLoadingText = createMode ? "Creating..." : "Updating...";

  return (
    <ValerieCard
      className="w-full"
      icon={<Icon />}
      title={title}
      actions={
        <>
          <Button className="h-7 w-20" variant="outline" size="sm" onClick={onCancel} disabled={isSaving}>
            Cancel
          </Button>
          <Button className="h-7 w-24" size="sm" onClick={handleSave} disabled={isSaving}>
            {isSaving ? saveButtonLoadingText : saveButtonText}
          </Button>
        </>
      }
    >
      {children}
    </ValerieCard>
  );
}
